import React from "react";
import { en_es } from "../pages/utils/I18n";
import { TableCell } from "@mui/material";

const RowHead = ({ data }: any) => {
  const { type, id, tableName, ...filteredData } = data;

  const dataFiltrada = filteredData;

  const mappedData = Object.keys(dataFiltrada).map((key) => {
    if (en_es.hasOwnProperty(key)) {
      return en_es[key];
    } else {
      return key;
    }
  });

  const tableRows = mappedData.map((text, index) => (
    <TableCell key={index} align="center">
      {text}
    </TableCell>
  ));

  return <React.Fragment>{tableRows}</React.Fragment>;
};

export default RowHead;
